import { buildEndpoint, genericGet, genericPost } from "../../../../services/api.service";
import { getDatasOperacao, getEstadoOperacao } from "../../utils";
import WarningIcon from '@mui/icons-material/Warning';
import { useContext, useState } from "react";
import { FactoryFloorContext } from "../../../../contexts/FactoryFloorContext";
import { IPeca, IPecaParaEntrega, TipoOperacao } from "../../../Obras/newObra/IObra";
import { MedidasConvencionalModal } from "./MedidasConvencionaisModal";
import toast from "react-hot-toast";
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import PecaParaOperacaoActions from "./PecaParaOperacaoActions";
import { ModalControloEQualidade } from "./ControloEQualidadeForm/ModalControloEQualidade";
import { useMutation, useQuery } from "@tanstack/react-query";
import { RelatorioControlo } from "../../../../types";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SumarioPecaEntrega = ({ data }: { data: IPecaParaEntrega }) => {

    const { selectionValues } = useContext(FactoryFloorContext);

    const estado = getEstadoOperacao(data, selectionValues.operacao);
    const datas = getDatasOperacao(data, selectionValues.operacao);

    const peca = data.peca as IPeca;

    return (
        <div
            className="border-2 border-zinc-200  rounded-md p-3 bg-zinc-100 text-xl">
            <p className="font-bold text-[1.3em] mb-2">Sumário</p>
            <hr className="border-zinc-500 mb-2" />
            <p className="mb-1"><span className="font-bold">Quantidade para a entrega:</span> {data.quantidade}</p>
            <p className="mb-1"><span className="font-bold">Material:</span> {peca.material?.reference}</p>
            <p className="mb-1"><span className="font-bold">Total de operações:</span> {peca.operacoes?.length}</p>
            <p className="mb-1"><span className="font-bold">Estado das operações:</span> {estado}</p>
            {peca?.operacoes[0]?.tipo == TipoOperacao.SERROTE && peca?.operacoes[0]?.isExternal ? <div>
                <p className="mb-1"><span className="font-bold">Data de entrega:</span> {peca?.operacoes[0]?.dataExpedicao}</p>
            </div> : <>
                <p className="mb-1"><span className="font-bold">Iniciado a:</span> {datas.start}</p>
                <p className="mb-1"><span className="font-bold">Terminado a:</span> {datas.end}</p>
            </>}

            {peca?.desenhosTecnicos?.length ? <>
                <hr className="border-zinc-500 mt-3 mb-1" />
                <p className="font-bold"><DesignServicesIcon /> Desenhos técnicos</p>
                {
                    peca.desenhosTecnicos.map((d: any) => (

                        <>
                            {
                                (d.name.split('.')[d.name.split('.').length - 1] == 'stp' || d.name.split('.')[d.name.split('.').length - 1]?.toLowerCase() == 'step') ?
                                    <a className="p-2" href={buildEndpoint(`/pecas/${peca.id}/desenhos-tecnicos/download/${d.id}`)} download>
                                        <div className="w-fit cursor-pointer mt-2 underline hover:no-underline" >{d.name}</div>
                                    </a> :
                                    <a className="p-2" href={buildEndpoint(`/pecas/${peca.id}/desenhos-tecnicos/download/${d.id}`)} target='__blank'>
                                        <div className="w-fit cursor-pointer mt-2 underline hover:no-underline" >{d.name}</div>
                                    </a>
                            }
                        </>
                    ))
                }
            </> : null}
            {data.medidasConvencionais ?
                <>
                    <hr className="border-zinc-500 mt-3 mb-1" />
                    <p className="font-bold"><ArchitectureIcon />Medidas pós-convencionais</p>
                    <p className="mb-1"><span className="font-bold">Largura:</span> {data.medidasConvencionais.largura} mm</p>
                    <p className="mb-1"><span className="font-bold">Altura:</span> {data.medidasConvencionais.altura} mm</p>
                    <p className="mb-1"><span className="font-bold">Comprimento:</span> {data.medidasConvencionais.comprimento} mm</p>

                </>
                : null}


        </div>

    )
}

function useFormControlChanges() {

    const [hasChanges, setHasChanges] = useState(false);

    return {
        hasChanges,
        setHasChanges
    }
}


export function PecaParaOperacaoHeader({ data, setPecasToDisplay, operacao }: { data: IPecaParaEntrega, setPecasToDisplay: (pecas: any[]) => void, operacao: any }) {

    const { selectionValues, setSelectionValues } = useContext(FactoryFloorContext);
    const [controloQualidadeFormOpen, setControloQualidadeFormOpen] = useState(false);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const relatoriControloState = useFormControlChanges();
    const navigate = useNavigate();

    const estado = getEstadoOperacao(data, selectionValues.operacao);

    const [requestMedidasConvencional, setRequestMedidasConvencional] = useState(false);

    const updatePecaState = async (pecaId: string | number) => {
        try {
            await (genericPost(`/pecas/process/${pecaId}/${selectionValues.operacao}`))(null);
            const updatedPecas = await genericGet(`/obras/${selectionValues.obra?.id}/entregas/${selectionValues.entrega?.id}/operacoes/${selectionValues.operacao}`)
            setPecasToDisplay(updatedPecas);
            toast.success('Estado transitado com sucesso!');
        } catch (e) {
            console.log("ERRO! ", e);
            toast.error('Erro ao atualizar estado')
        }

    }



    const updateMedidasConvencional = async (pecaId: string | number, medidas: any) => {
        try {
            await (genericPost(`/pecas/medidas/${pecaId}`))(medidas);
            toast.success('Medidas atualizadas com sucesso!');
            const updatedPecas = await genericGet(`/obras/${selectionValues.obra?.id}/entregas/${selectionValues.entrega?.id}/operacoes/${selectionValues.operacao}`)
            toast.success('Estado transitado com sucesso!');
            setPecasToDisplay(updatedPecas);

        } catch (e) {
            toast.error('Erro ao atualizar medidas!')
        }

    }

    const actionsPossible = () => {

        return !(operacao.tipo == TipoOperacao.SERROTE && operacao.isExternal) && operacao.tipo !== 'Controlo e Qualidade' && operacao.tipo !== TipoOperacao.TRATAMENTO;

    }

    const controloEQualidade = () => {
        return operacao.tipo == 'Controlo e Qualidade';
    }

    const { data: relatorioControlo, refetch: fetchRelatorio } = useQuery<RelatorioControlo>({
        queryKey: ['relatorioControlo', data.id],
        queryFn: async () => {
            if (controloEQualidade()) return (await axios.get(buildEndpoint(`/relatorios-controlo/${data.id}`))).data;
        },
        onSuccess: (data: any) => {
            console.log("Got relatorio controlo: ", data);
        }

    })

    const deleteRelatorioMutation = useMutation(() => axios.delete(buildEndpoint(`/relatorios-controlo/${data.id}`)), {});

    return (
        <>

            {controloEQualidade() ?
                <ModalControloEQualidade
                    relatorioControlo={relatorioControlo}
                    pecaEntrega={data}
                    fetchRelatorio={fetchRelatorio}
                    setConfirmationModalOpen={setConfirmationModalOpen}
                    setControloQualidadeFormOpen={setControloQualidadeFormOpen}
                    confirmationModalOpen={confirmationModalOpen}
                    controloQualidadeFormOpen={controloQualidadeFormOpen}
                    relatoriControloState={relatoriControloState}

                /> : null}
            <MedidasConvencionalModal
                isOpen={requestMedidasConvencional}
                onCancel={() => setRequestMedidasConvencional(false)}
                onConfirm={(info: any) => {
                    updateMedidasConvencional(data.id, info)
                        .then(() => {
                            if (data.estadoConvencionais === "Concluído") {
                                setRequestMedidasConvencional(false);
                            } else {
                                updatePecaState(data.id)
                                    .then(() => setRequestMedidasConvencional(false))
                            }
                        })
                }}
                initialValues={data.medidasConvencionais}
            />
            <div className="flex items-center p-5 rounded-md bg-zinc-600">
                <div className="w-3/5">
                    <div className="flex items-center justify-between mb-2">
                        <h2 className="text-[1.8em]  font-bold text-white">{(data.peca as IPeca).reference}</h2>
                        {data.naoConformidadeCliente ? <div
                            className="flex items-center p-2 bg-rodrimaq-red rounded-md ml-4 text-white hover:opacity-70 cursor-pointer"
                            onClick={() => navigate(`/nao-conformidades-clientes/${data.naoConformidadeCliente.id}`)}
                        >
                            <NewReleasesIcon />
                            <div className="ml-2 font-bold"> Peça com não conformidade </div>
                        </div> : null}
                    </div>

                    <SumarioPecaEntrega data={data} />
                </div>
                {actionsPossible() ?
                    <PecaParaOperacaoActions
                        estado={estado}
                        updatePecaState={updatePecaState}
                        setPecasToDisplay={setPecasToDisplay}
                        data={data}
                        setRequestMedidasConvencional={setRequestMedidasConvencional}
                    />
                    : <>{
                        operacao.tipo == TipoOperacao.SERROTE || operacao.tipo == TipoOperacao.TRATAMENTO ?
                            <div className="flex flex-col items-center justify-center w-2/5 text-white">

                                <WarningIcon style={{ fontSize: '8em' }} />

                                <div className="text-lg font-bold mt-3">Operação externa</div>
                            </div> : null}
                    </>}

                {controloEQualidade() ?
                    <div>
                        {
                            relatorioControlo ?
                                <div className="text-white ml-5 p-5 flex items-center justify-between">
                                    <div>
                                        <div>Conformidade: {relatorioControlo?.conforme ? 'Sim' : 'Não'}</div>
                                        <div>Observações: {relatorioControlo?.observacoes}</div>
                                        <div>Efetuado por: {relatorioControlo?.submetidoPor?.name}</div>
                                        <div>Efetuado em: {relatorioControlo?.created_at?.split('T')[0]}</div>
                                    </div>
                                    <button className="text-white bg-rodrimaq-red ml-10 p-4 rounded border border-rodrimaq-red cursor-pointer hover:bg-white hover:text-rodrimaq-red" onClick={() => deleteRelatorioMutation.mutate()}>
                                        Reset
                                    </button>
                                </div>

                                : null
                        }
                        <button className="text-white bg-rodrimaq-red ml-10 p-4 rounded border border-rodrimaq-red cursor-pointer hover:bg-white hover:text-rodrimaq-red" onClick={() => setControloQualidadeFormOpen(true)}>
                            Relatório para controlo de qualidade
                        </button>
                    </div>

                    : null}

            </div>
        </>)


}